export default __webpack_public_path__ + "static/media/C891.e66ae973.webp";